import axios from "axios";
import { createFormHeadersAdmin, createHeadersAdmin } from "../../utils/Utils";
import { BASE_URL } from "../../assets/constants/constants";

//  Image Add
export const uploadImageAPI = async (data) => {
  const headers = createFormHeadersAdmin();
  return await axios.post(`${BASE_URL()}upload-pages`, data, headers);
};
//  Image List
export const imageListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}get-pages`, data, headers);
};
//  Image delete
export const deleteImageAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}delete-pages`, data, headers);
};